import React from 'react';
import Card from '@mui/material/Card';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { SoftIcon } from '../ui/SoftIcon';

export function FieldCard({ icon, tone, title, subtitle, children }) {
  const theme = useMuiTheme();
  return (
    <Card
      sx={{
        p: 2,
        borderRadius: '18px',
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[2],
        background: theme.palette.background.paper,
      }}
    >
      <MDBox display="flex" alignItems="center" gap={1.2} sx={{ mb: 1.25 }}>
        <SoftIcon icon={icon} tone={tone} />
        <MDBox sx={{ minWidth: 0 }}>
          <MDTypography variant="button" fontWeight="bold" sx={{ opacity: 1, lineHeight: 1.1 }}>
            {title}
          </MDTypography>
          {subtitle ? (
            <MDTypography
              variant="caption"
              sx={{ color: theme.palette.text.secondary, opacity: 1 }}
            >
              {subtitle}
            </MDTypography>
          ) : null}
        </MDBox>
      </MDBox>

      <MDBox sx={{ display: 'grid', gap: 1.25 }}>{children}</MDBox>
    </Card>
  );
}
